export const noteFeedFlexPaneTitle = "p06aRb";
export default {noteFeedFlexPaneTitle};